__turbopack_context__.v({
  "fail": "formButtonGrow-module-scss-module__iHM9gq__fail",
  "formButtonGrow": "formButtonGrow-module-scss-module__iHM9gq__formButtonGrow",
  "formButtonGrowContent": "formButtonGrow-module-scss-module__iHM9gq__formButtonGrowContent",
  "formButtonGrowElement": "formButtonGrow-module-scss-module__iHM9gq__formButtonGrowElement",
  "growCard": "formButtonGrow-module-scss-module__iHM9gq__growCard",
  "loader": "formButtonGrow-module-scss-module__iHM9gq__loader",
  "success": "formButtonGrow-module-scss-module__iHM9gq__success",
});
